import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { SelectPaymentMethodModalComponent } from './select-payment-method-modal/select-payment-method-modal.component';
import {
  SimpleMessageModalComponent
} from '../../../../components/modals/simple-message-modal/simple-message-modal.component';

import { PaymentProcessorType } from '../../../../models/organization-config-enums';


export function initPayment(modalService: NgbModal,
                            invoiceId: number,
                            paymentProcessorType: PaymentProcessorType,
                            customerId: number,
                            paymentDescription: string,
                            successUrl: string,
                            cancelUrl: string,
                            onSuccess: () => void,
                            amount?: number,
                            onClose?: () => void) {
  const modalRef = modalService.open(SelectPaymentMethodModalComponent);
  const instance = modalRef.componentInstance;

  modalRef.componentInstance.invoiceId = invoiceId;
  modalRef.componentInstance.paymentProcessorType = paymentProcessorType;
  modalRef.componentInstance.customerId = customerId;
  modalRef.componentInstance.paymentDescription = paymentDescription;
  modalRef.componentInstance.successUrl = successUrl;
  modalRef.componentInstance.cancelUrl = cancelUrl;
  modalRef.componentInstance.onSuccess = onSuccess;
  modalRef.componentInstance.amount = amount;
  modalRef.componentInstance.onClose = onClose;

  // The reader path hands off to a second modal whose own close fires onClose, so
  // this close must not fire it too. Read the flag from the captured instance:
  // ng-bootstrap clears modalRef.componentInstance before the result settles.
  const finish = () => {
    if (!instance.handedOffToReaderModal) {
      onClose?.();
    }
  };
  modalRef.result.then(finish, finish);
}


// When an MX Merchant payment fails, the user is redirected back to the cancelUrl
// supplied to initPayment with an "error" GET parameter (unlike Stripe and Gravity,
// which surface the failure on their own pages). Pages that host an initPayment call
// invoke this helper in ngOnInit to surface that error to the user.
export function displayMXMerchantCancelError(modalService: NgbModal,
                                             route: ActivatedRoute,
                                             router: Router) {
  const errorMessage = route.snapshot.queryParamMap.get('error');
  if (!errorMessage) { return; }

  const modalRef = modalService.open(SimpleMessageModalComponent);
  modalRef.componentInstance.headerText = 'Payment Failed';
  modalRef.componentInstance.messageText = errorMessage;
  modalRef.componentInstance.messageAlertClass = 'alert-danger';

  router.navigate([], {
    relativeTo: route,
    queryParams: { error: null },
    queryParamsHandling: 'merge',
    replaceUrl: true,
  });
}
